import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H3 from '@base/H3/H3';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { FAQList } from '@cont/Batch/BatchFaqs';

const Wrapper = styled.div`
  max-width: 752px;
  grid-column: span 24;
  display: grid;
  grid-template-rows: ${Spacings.SPACING_13B} auto;
`;

const TitleWrapper = styled(H3)`
  ${mediaQuery.uptoMobile} {
    font-weight: bold;
    font-size: ${Fonts.H5};
    line-height: 120%;
    display: flex;
    align-items: center;
  }
`;

const InnerWrapper = styled.div`
  display: grid;
  z-index: 1;
  .MuiAccordion-root {
    padding-left: ${Spacings.SPACING_7B} !important;
  }
  ${mediaQuery.uptoMobile} {
    .h5 {
      line-height: 120%;
    }
    .MuiAccordion-root {
      padding: ${Spacings.SPACING_4B} !important;
    }
  }
`;

const PFBatchFaqs = ({ faqs }) => {
  if (!faqs?.length) return null;
  return (
    <Wrapper>
      <TitleWrapper>FAQs</TitleWrapper>
      <InnerWrapper>
        <FAQList faqs={faqs} />
      </InnerWrapper>
    </Wrapper>
  );
};
export default PFBatchFaqs;

PFBatchFaqs.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired
};
